import { lazy } from "react";
import { CameraIcon, InstagramIcon } from "@signet/ui";
import { defineWebModule, lazyPage } from "@signet/web-kit";
import { MainAccountsPage } from "./page.tsx";
import "./mainaccounts.css";

/* The web half of Main Accounts: one page, standalone in the nav (Jay, 2026-10-15), and Trial
   Reels (Jay, 2026-10-22) as a tab on each creator's page on Creators and a page in their portal. */

const str = (value: unknown) => (typeof value === "string" && value ? value : undefined);

const TrialReelsTab = lazy(() => import("./trial.tsx").then((m) => ({ default: m.TrialReelsTab })));
const TrialReelsPage = lazyPage(() => import("./portal-trial.tsx"), "TrialReelsPage");
const AnalyticsPage = lazyPage(() => import("./analytics.tsx"), "AnalyticsPage");

export default defineWebModule({
  id: "mainaccounts",
  nav: { label: "Main Accounts", icon: InstagramIcon, to: "/main-accounts", needs: "mainaccounts.account:view" },
  routes: [
    { path: "/main-accounts", component: MainAccountsPage, needs: "mainaccounts.account:view", validateSearch: (raw) => ({ period: str(raw.period) }) },
    // What Auto-Downloads saved each day (Jay, 2026-10-26), for whoever can see Auto-Downloads.
    { path: "/main-accounts/analytics", component: AnalyticsPage, needs: "mainaccounts.download:view", validateSearch: (raw) => ({ day: str(raw.day), creator: str(raw.creator) }) },
  ],
  commands: [
    { id: "mainaccounts.page", label: "Main Accounts", to: "/main-accounts", needs: "mainaccounts.account:view", hint: "Creators' posting", keywords: "instagram main accounts posts reels posting frequency creators" },
    { id: "mainaccounts.analytics", label: "Main Accounts analytics", to: "/main-accounts/analytics", needs: "mainaccounts.download:view", hint: "Auto-Downloads each day", keywords: "downloads downloaded uploaded drive photos videos daily" },
  ],
  creatorTabs: [{ id: "trial-reels", label: "Trial Reels", needs: "mainaccounts.account:view", order: 10, component: TrialReelsTab }],
  portal: {
    for: "creators",
    pages: [{ path: "trial-reels", label: "Trial Reels", short: "Trials", icon: CameraIcon, order: 30, component: TrialReelsPage }],
  },
});
